export function productMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateProductId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateProductId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyProduct(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productId: resource.objectId,
    })),
  };
}

export function productMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, productId: json.result.objectId},
  };
}